module.exports = __webpack_public_path__ + "static/img/MA.ffc8b6e1.jpg";